import { Container, Grid } from '@mui/material'
import React, { useRef } from 'react'
import { motion, useScroll, useTransform } from 'framer-motion'
import { useNavigate } from 'react-router-dom'
import Hello from './Hello'
import projectsData from '../data/projects.json'

// CSS property (left/right) and corresponding MotionValue key for each project
const ANIMATION_MAP = [
  { styleProp: 'left', valueKey: 'left' },
  { styleProp: 'right', valueKey: 'right' },
  { styleProp: 'left', valueKey: 'left1' },
  { styleProp: 'right', valueKey: 'right1' },
  { styleProp: 'left', valueKey: 'left2' },
  { styleProp: 'right', valueKey: 'right2' },
  { styleProp: 'left', valueKey: 'left3' },
  { styleProp: 'right', valueKey: 'right3' },
]

const Expertise = ( { view } ) => {
    const targetRef = useRef( null )
    const navigate = useNavigate();
    const { scrollYProgress } = useScroll( {
        target: targetRef,
        offset: ['start end', 'end start'],
    } )

    const left = useTransform( scrollYProgress, view === 'web' ? [0, 0.25] : [0, 0.2], view === 'web' ? ['100%', '0%'] : ['30%', '0%'] )
    const right = useTransform( scrollYProgress, view === 'web' ? [0, 0.25] : [0, 0.2], view === 'web' ? ['100%', '0%'] : ['30%', '0%'] )
    const left1 = useTransform( scrollYProgress, view === 'web' ? [0.25, 0.42] : [0.2, 0.4], view === 'web' ? ['100%', '0%'] : ['30%', '0%'] )
    const right1 = useTransform( scrollYProgress, view === 'web' ? [0.22, 0.42] : [0.2, 0.4], view === 'web' ? ['100%', '0%'] : ['30%', '0%'] )
    const left2 = useTransform( scrollYProgress, view === 'web' ? [0.42, 0.62] : [0.4, 0.6], view === 'web' ? ['100%', '0%'] : ['30%', '0%'] )
    const right2 = useTransform( scrollYProgress, view === 'web' ? [0.42, 0.62] : [0.4, 0.6], view === 'web' ? ['100%', '0%'] : ['30%', '0%'] )
    const left3 = useTransform( scrollYProgress, view === 'web' ? [0.62, 0.72] : [0.6, 0.8], view === 'web' ? ['100%', '0%'] : ['30%', '0%'] )
    const right3 = useTransform( scrollYProgress, view === 'web' ? [0.62, 0.72] : [0.6, 0.8], view === 'web' ? ['100%', '0%'] : ['30%', '0%'] )

    const animationValues = { left, right, left1, right1, left2, right2, left3, right3 }
    const sortedProjects = [...projectsData].sort( ( a, b ) => ( a.displayOrder || 0 ) - ( b.displayOrder || 0 ) )

    return (
        <div
            className="work"
            style={ { marginBlockStart: "20px", paddingBlockStart: "50px", overflow: 'hidden' } }>
            <Hello view={ view } />
            <Grid
                ref={ targetRef }
                container
                sx={ {
                    padding: "40px 30px",
                    textAlign: "left",
                } }
            >
                { sortedProjects.map( ( project, index ) => {
                    const animConfig = ANIMATION_MAP[index]
                    const styleProp = animConfig
                        ? { [animConfig.styleProp]: animationValues[animConfig.valueKey] }
                        : {}
                    const isLast = index === sortedProjects.length - 1

                    return (
                        <Grid
                            key={ project.id }
                            item
                            md={ 6 }
                            xs={ 12 }
                        >
                            <motion.div
                                className='goers'
                                style={ {
                                    ...styleProp,
                                    position: 'relative',
                                    paddingBlockStart: "15px",
                                    paddingInlineEnd: `${view === "web" ? "20px" : "0px"}`,
                                    marginBlockEnd: `${view === "mobile" && "10px"}`,
                                    borderRadius: "5px",
                                    // ...( isLast && { padding: "0px" } ),
                                } }
                                onClick={ () => navigate( `/${project.id}` ) }
                            >
                                <Container sx={ { padding: "0px !important", overflow: "hidden" } }>
                                    <img
                                        src={ project.cardImage }
                                        alt={ project.cardTitle }
                                        className="ckImg"
                                        style={ isLast? {backgroundColor: "white"} : {backgroundColor: "none"} }
                                    />
                                </Container>
                                <Container
                                    sx={ {
                                        padding: "15px",
                                        backgroundColor: "#eeeeee",
                                    } }
                                >
                                    <div
                                        style={ {
                                            fontSize: "20px",
                                            fontWeight: "bold",
                                            marginBlockEnd: "8px",
                                        } }
                                    >
                                        { project.cardTitle }
                                    </div>
                                    <div className="proDes">{ project.cardDescription }</div>
                                </Container>
                            </motion.div>
                        </Grid>
                    )
                } ) }
            </Grid>
        </div>
    )
}

export default Expertise
